import { Article } from './article';
import { PDF } from './documents';

export class MagazineDetailData {
  magazine: Magazine | null = null;
  articles: Article[] = [];
  editorial: Editorial | null = null;
  magazines: Magazine[] = [];
}

export interface Editorial {
  id: number;
  title: string;
  content: string;
  slug: string;
  subtitle: null | string;
  image: string;
  cover: string;
  caption: null | string;
  author_id: number | null;
  subject_id: number | null;
  author: Author | null;
  subject: Subject | null;
}

export interface Author {
  id: number;
  name: string;
  surname: string;
}

export interface Subject {
  id: number;
  name: string;
}

export interface Magazine {
  id: number;
  title: string;
  cover: string;
  number: number;
  topic: string;
  season: string;
  pdf: PDF[];
  slug: string;
  featured: null | string;
  current: number;
}
